import styled from 'styled-components';
import { Row } from '../../styled';

export const MainCampaigns = styled.div`
    width: 100%;
    margin-top: 32px;
`;

export const RowsFlexWrapper = styled(Row)`
    flex-direction: column;
    gap: 8px;
`;
